<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
    ModelListSelect,

  },

  data() {
    return {
      title: "Store Stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Store Stock",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsStoreStockPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      is_exporting: false,
      modal_id: "",
      edit: {
        id: "",
        buying: "",
      },
      editData: {
        id: "",
      },
      filterProducts: {
        product: '',
        category: '',
        store: '',
        page: 1,
        per_page: 50,
      },
       json_fields: {
        CATEGORY: "category",
        PRODUCT_NAME: "name",
        UNITS: "baseunit",
        PRODCUT_CODE: "product_code",
        QUANTITY: "qty",
        BUYING_PRICE: "buying_price",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
       exportStock() {
        this.is_exporting = true;
        axios
          .post("store/export", this.filterProducts, {
            responseType: "arraybuffer",
          })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "store-stock-list.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.is_exporting = false;
          })
          .catch(() => {
            this.is_exporting = false;
          });
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("store", [
      "SaveStatus",
      "FilterStatus",
      "StoreStock",
      "StoreStockPagination",
      "StoreStockSummary",
      "StoreStockPaginated"
    ]),
    ...mapGetters("auth", ["branchid"]),
    ...mapGetters("products", ["Categories"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "branchid", "Branches"]),

    stockColumns() {
      const cols = [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) =>
            this.StoreStockPagination?.from
              ? this.StoreStockPagination.from + idx
              : idx + 1,
        },
        {
          key: "product_name",
          label: "PRODUCT",
          formatter: (_, row) => row.product?.product_name || "N/A",
        },
        {
          key: "buying_p",
          label: "BUYING PRICE",
        },
      ];

      if (this.branchid == 0) {
        cols.push({
          key: "branch",
          label: "BRANCH",
        });
      }

      cols.push(
        {
          key: "in_stock",
          label: "IN STOCK",
        },
        {
          key: "selling_price",
          label: "SELLING PRICE",
        },
        {
          key: "reserve_price",
          label: "RESERVE PRICE",
        },
        {
          key: "action",
          label: "ACTION",
        }
      );

      return cols;
    },

    rows() {
      return this.IsStoreStockPaginated
        ? this.StoreStockPagination.total
        : this.StoreStock
        ? this.StoreStock.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStoreStockPaginated) {
          return (
            this.StoreStockPagination.per_page ||
            this.filterProducts.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStoreStockPaginated) {
          this.filterProducts.per_page = value;
          this.filterProducts.page = 1;
          this.FetchStore(this.filterProducts);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StoreStockPaginated && this.StoreStockPagination
          ? this.StoreStockPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StoreStockPaginated) {
          this.filterProducts.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totalSellingPriceValue() {
      return this.StoreStockSummary ? this.StoreStockSummary.total_selling_price_value : 0;
    },

    totalBuyingPriceValue() {
      return this.StoreStockSummary ? this.StoreStockSummary.total_buying_price_value : 0;
    }
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchStore: "store/fetchStoreStockData",
      EditBPrice: "store/editBPrice",
      FetchCategories: "products/fetchPCategories",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchStores: "store/fetchStores",
    }),

    onFiltered() {
      if (!this.IsStoreStockPaginated) {
        this.clientCurrentPage = 1;
      }
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      return m != null && m !== ""
        ? m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : m;
    },

    addCommas() {
      this.edit.buying = this.thousandSeperator(this.edit.buying);
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    ShowEdit(data) {
      this.edit.id = data.id;
      this.edit.buying = this.thousandSeperator(data.buying_price);
    },
    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.edit.buying == "") {
        return;
      }
      this.EditBPrice(this.edit);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // handleServerSearch() {
    //   this.filterProducts.page = 1;
    //   this.FetchStore(this.filterProducts);
    // },
    FilterStore() {
      this.filterProducts.page = 1;
      this.FetchStore(this.filterProducts);
    },

    handlePageChange(newPage) {
      if (this.IsStoreStockPaginated) {
        this.filterProducts.page = newPage;
        this.FetchStore(this.filterProducts);
      }
    },

    handlePerPageChange(newPerPage) {
      if (this.IsStoreStockPaginated) {
        this.filterProducts.page = 1;
        this.filterProducts.per_page = newPerPage;
        this.FetchStore(this.filterProducts);
      }
    },

    // redirect(id) {
    //   this.$router.push(`/product_movements/${btoa(id)}`);
    // },
    redirect(value) {
      this.$router.push(
        `/store/movements/${btoa(value)}`
      );
    },
  },

  created() {
    this.FetchStore(this.filterProducts);
    this.FetchCategories();
    this.FetchGeneralSettings();

  },
  
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Store Stock Level In Different Units</h4>
              </div>
               <div class="col-md-3" align="right">
                <b-button variant="info" class="me-2" @click="exportStock()" :disabled="is_exporting">
                  <span v-if="!is_exporting">
                    Export Excel <i class="fa fa-download"></i>
                  </span>
                  <span v-else>
                    <b-spinner small></b-spinner> Exporting...
                  </span>
                </b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-3 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
             
              <div class="mb-2 col-sm-12 col-md-4 form-group d-flex flex-column justify-content-end">
                <label>SEARCH BY CATEGORY</label>
                <model-list-select :list="Categories ? [{ id: '', catName: 'All Categories' }, ...Categories] : []"
                  v-model="filterProducts.category" option-value="id" option-text="catName"
                  placeholder="Select Category" @input="FilterStore()">
                </model-list-select>
              </div>
              <!-- Search -->
              <div class="mb-2 col-sm-12 col-md-5 form-group d-flex flex-column justify-content-end">
                <label>SEARCH PRODUCT</label>
                <div class="input-group">
                  <input
                    v-model="filterProducts.product"
                    type="text"
                    class="form-control"
                    placeholder="Search by product name or code..."
                    @keyup.enter="FilterStore()"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="FilterStore()">
                      <b-spinner v-if="FilterStatus" variant="light" small label="Searching"></b-spinner>
                      <span>Search</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="stockColumns"
                :rows="StoreStockPaginated || []"
                :total-rows="rows"
                :pagination="StoreStockPagination"
                :server-pagination="IsStoreStockPaginated"
                :loading="FilterStatus"
                row-class="store-stock-table-bordered"
              >
                <template #cell(sn)="{ index }">
                  {{
                    StoreStockPagination?.from
                      ? StoreStockPagination.from + index
                      : index + 1
                  }}
                </template>

                <template #cell(product_name)="{ row }">
                  {{ row.product?.product_name || "N/A" }}
                </template>

                <template #cell(buying_p)="{ row }">
                  <span
                    class="text-warning"
                    style="cursor: pointer"
                    v-b-modal.expired-modal
                    @click="ShowEdit(row)"
                  >
                    {{ thousandSeperator(row.buying_price) }}
                  </span>
                </template>

                <template #cell(branch)="{ row }">
                  {{ row.branch ? row.branch.name : "N/A" }}
                </template>

                <template #cell(in_stock)="{ row }">
                  <div v-for="(det, d) in row.units" :key="d" class="mb-4">
                    {{ Math.floor(row.qty / det.base_quantity) }}
                    {{ det.unitname }}
                  </div>
                </template>

                <template #cell(selling_price)="{ row }">
                  <div v-for="(det, d) in row.units" :key="d" class="mb-4">
                    {{ thousandSeperator(det.selling) }}
                  </div>
                </template>

                <template #cell(reserve_price)="{ row }">
                  <div v-for="(det, d) in row.units" :key="d" class="mb-4">
                    {{ thousandSeperator(det.reserve) }}
                  </div>
                </template>

                <template #cell(action)="{ row }">
                  <b-button
                    size="sm"
                    variant="success"
                    @click="redirect(row.id)"
                  >
                    <i class="fa fa-retweet"></i> Movements
                  </b-button>
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-6">
                  <h5>
                    Buying price stock value:
                    <span class="text-danger">{{
                      thousandSeperator(totalBuyingPriceValue)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-6" align="right">
                  <h5>
                    Selling price stock value:
                    <span class="text-danger">{{
                      thousandSeperator(totalSellingPriceValue)
                    }}</span>
                  </h5>
                </div>
               
               
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer>
      <template #modal-title>
        <h4 class="text-warning">
          Edit Buying Price of {{ thousandSeperator(edit.buying) }}
        </h4></template
      >
      <label>Buying Price</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="edit.buying"
          placeholder="Buying Price"
          @input="addCommas()"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('expired-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="editAmt('expired-modal')"
        >
          <i class="fa fa-minus"></i> Confirm
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

/* .store-stock-table-bordered td {
  border-bottom: 1px solid #000 !important;
} */
</style>
